module.exports = require("license-webpack-plugin");